import { render, staticRenderFns } from "./CustomOccupationAddSkills.vue?vue&type=template&id=22eecb26&scoped=true&"
import script from "./CustomOccupationAddSkills.vue?vue&type=script&lang=js&"
export * from "./CustomOccupationAddSkills.vue?vue&type=script&lang=js&"
import style0 from "./CustomOccupationAddSkills.vue?vue&type=style&index=0&id=22eecb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eecb26",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomOccupationSuggestedSkills: require('/workspace/components/CustomOccupation/CustomOccupationDetail/CustomOccupationSuggestedSkills.vue').default})
